module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "toolbar"
    }
  }, [_c('div', {
    staticClass: "logo",
    attrs: {
      "title": "Infobits 2.6"
    }
  }, [_vm._v("INFOBITS 2")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "create-panel"
    }
  }, _vm._l((_vm.typeDefs), function(typeDef, type) {
    return _c('span', {
      class: ['type-box', 'hoverable', {
        'disabled': !_vm.user
      }],
      attrs: {
        "title": 'Create ' + typeDef.name
      },
      on: {
        "click": function($event) {
          return _vm.newInfobit(type)
        }
      }
    }, [_c('span', {
      class: ['fa', _vm.iconClass(type)]
    }), _vm._v(" "), _c('span', {
      staticClass: "type-name"
    }, [_vm._v(_vm._s(typeDef.name))])])
  }), 0), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "login-state"
    }
  }, [(_vm.user) ? [_vm._v("\n      Logged in as "), _c('b', [_vm._v(_vm._s(_vm.user))]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "link hoverable",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])] : _c('span', {
    staticClass: "link hoverable",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])], 2), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hoverable",
    attrs: {
      "id": "help"
    }
  }, [_c('span', {
    staticClass: "fa fa-question-circle-o"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "../../static/help.html",
      "target": "_blank"
    }
  }, [_vm._v("Help")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "legal"
    }
  }, [_c('a', {
    staticClass: "hoverable",
    attrs: {
      "href": "https://nosconte.com/impressum.html",
      "target": "_blank"
    }
  }, [_vm._v("Impressum")]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "hoverable",
    attrs: {
      "href": "https://nosconte.com/datenschutz.html",
      "target": "_blank"
    }
  }, [_vm._v("Privacy")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5a68ee94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/toolbar.vue
// module id = 144
// module chunks = 0